import React from "react";
import { SearchOutlined } from "@mui/icons-material";
import { useDebounce } from "../hooks/useDebounce";

export const CustomSearchBar = (props) => {

    const { action, placeholder, disabled } = props;
    const { onQueryChanged } = useDebounce(action);
 
    return (
        <div style={{ borderRadius: 4, border: '1px solid #bdbdbd', padding: 7.5, display: 'flex', alignItems: 'center', gap: 6 }}>
            <SearchOutlined fontSize="small" htmlColor='grey' />
            <input 
                type="text" 
                onChange={ onQueryChanged }
                placeholder={ placeholder }
                style={{ border: 'none', outline: 'none', padding: 0, width: '100%' }}
                disabled={ disabled }
            />
        </div>
    );
}

CustomSearchBar.defaultProps = {
    action: () => false,
    placeholder: 'Buscar',
    disabled: false
}